import React, { forwardRef } from "react";
import { defineMessages, useIntl } from "react-intl";
import "./TableLegend.scss";
import { assessmentDescription } from "../../../../../../utils/messages";
import { Chip } from "@evidenceb/athena-common/design-system/Chip";
import useTheme from "../../../../../../hooks/useTheme";
import { useFeatureFlag } from "@evidenceb/athena-common/modules/FeatureFlags";

const TableLegend = forwardRef<HTMLUListElement, unknown>((_, ref) => {
    const intl = useIntl();
    const theme = useTheme();
    const motivationalMessages = useFeatureFlag("motivationalMessages");
    return (
        <ul className="table-legend" ref={ref}>
            <li>
                <Chip
                    icons={[
                        {
                            path: "objective_unopened",
                            color: "var(--element-objective-background-not-explored)",
                        },
                    ]}
                    input={intl.formatMessage(messages.objectiveNotStarted)}
                    colorMode={theme}
                    size="large"
                />
            </li>

            <li>
                <Chip
                    icons={[
                        {
                            path: "objective_in-progress",
                            color: "var(--element-teacher-default)",
                        },
                    ]}
                    input={intl.formatMessage(messages.currentObjective)}
                    colorMode={theme}
                    size="large"
                />
            </li>

            <li>
                <Chip
                    icons={[
                        {
                            path: "objective_completed",
                            color: "var(--element-teacher-default)",
                        },
                    ]}
                    input={intl.formatMessage(messages.validObjective)}
                    colorMode={theme}
                    size="large"
                />
            </li>

            <li>
                <Chip
                    icons={[
                        {
                            path: "alert_strength",
                        },
                    ]}
                    input={intl.formatMessage(
                        assessmentDescription[`assessment-strength`]
                    )}
                    colorMode={theme}
                    size="large"
                />
            </li>
            <li>
                <Chip
                    icons={[
                        {
                            path: "alert_weakness",
                        },
                    ]}
                    input={intl.formatMessage(
                        assessmentDescription[`assessment-weakness`]
                    )}
                    colorMode={theme}
                    size="large"
                />
            </li>
            {motivationalMessages && (
                <li>
                    <Chip
                        icons={[
                            {
                                path: "alert_blocked",
                            },
                        ]}
                        input={intl.formatMessage(
                            assessmentDescription[`assessment-blocked`]
                        )}
                        colorMode={theme}
                        size="large"
                    />
                </li>
            )}
        </ul>
    );
});

export default TableLegend;

const messages = defineMessages({
    objectiveNotStarted: {
        id: "dashboard-progressionOverview-legend-objectiveNotStarted",
        defaultMessage: "Objective not started",
    },
    currentObjective: {
        id: "dashboard-progressionOverview-legend-currentObjective",
        defaultMessage: "Current objective",
    },
    validObjective: {
        id: "dashboard-progressionOverview-legend-validObjective",
        defaultMessage: "Completed objective",
    },
    progressionAcceleration: {
        id: "dashboard-progressionOverview-legend-progressionAcceleration",
        defaultMessage: "Overcome difficulty",
    },
    progressionRegression: {
        id: "dashboard-progressionOverview-legend-progressionRegression",
        defaultMessage: "Difficulty encountered",
    },
});
